module.exports = __webpack_public_path__ + "img/miaoshu2.b20181c6.png";